/**
 * Ar App
 * This is a simple API for AR App
 *
 * OpenAPI spec version: 1.0.0
 * Contact: csong@lsq.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Information to add links or actions to labels
 */
export interface LabelFieldOptionLinks { 
    /**
     * The start index where we added the linked text
     */
    startIndex?: number;
    /**
     * The end index where we added the linked text
     */
    endIndex?: number;
    /**
     * The text that we use for redirect or for call an specific endpoint
     */
    link?: string;
    /**
     * Actions that we can use
     */
    action?: LabelFieldOptionLinks.ActionEnum;
}
export namespace LabelFieldOptionLinks {
    export type ActionEnum = 'Redirect' | 'Api';
    export const ActionEnum = {
        Redirect: 'Redirect' as ActionEnum,
        Api: 'Api' as ActionEnum
    };
}